import axios from 'axios';
import qs from 'query-string';
import { $env } from '@whitetail/buckshot/scripts/core/core';

const urls = {
    local: 'https://api.wpsite.test',
    localdev: 'https://api.wpsite.dev',
    sandbox: 'https://api.wpsite.sandbox.us',
    staging: 'https://api.wpsitestage.dev',
    production: 'https://api.whitetailproperties.com',
};

const instance = axios.create({
    baseURL: urls[$env()],
    withCredentials: true,
    paramsSerializer: (params) => qs.stringify(params),
});

instance.interceptors.request.use(async (config) => {
    if (config.method !== 'get') {
        await instance.get('/csrf')
            .then((response) => {
                const { token } = response.data;

                config.headers['X-CSRF-Token'] = token;
            });
    }

    return config;
});

export default instance;
